import { TRAVELLER_TYPE_KEY, TRIP_TYPE_KEY } from '@trip-ux/constants';
import {
  QuoteStoreResponse,
  RecommendationStoreResponse,
  ReduxStore,
  TravellerParams,
  TravellerProduct,
  RecommendationPlanResponse,
  TravellerDetailsPayload,
  TravellerPayment
} from '@trip-ux/redux-store';
import { find, get, filter, isEmpty, toLower } from 'lodash';

export const travellerPaymentSelector = (store: ReduxStore, paxId: number): TravellerPayment =>
  get(store.travellerPayment, paxId, { paxId });

export const recommendationSelector = (store: ReduxStore, paxId: number): RecommendationStoreResponse =>
  get(store.recommendation, paxId);

export const dobErrorSelector = (store: ReduxStore, paxId: number): string | undefined =>
  get(store.recommendation.dobError, paxId);

export const dobFocusSelector = (store: ReduxStore, paxId: number): boolean =>
  get(store.recommendation.dobFocus, paxId, false);

export const quoteSelector = (store: ReduxStore, paxId: number): QuoteStoreResponse => get(store.quote, paxId);

export const travellerPlanSelector = (store: ReduxStore, paxId: number): TravellerProduct[] =>
  filter(store.travellersPlan.products, { paxId });

export const travellerPlanParamsSelector = (store: ReduxStore, paxId: number, plan: string): TravellerParams =>
  find(store.travellersPlan.tripParams, { paxId, plan });

export const hasError = ele => find(ele, e => e.error && !isEmpty(e.error));

export const addOnPlansSelector = (store: ReduxStore, paxId: number): RecommendationPlanResponse[] => {
  const products = recommendationSelector(store, paxId);
  return filter(get(products, 'recommendationData.plans', []), product =>
    find(store.recommendation.productContents, { code: product.code, type: 'addon' })
  );
};

export const travellerDetailsSelector = (store: ReduxStore, paxId: number): TravellerParams[] =>
  filter(store.travellersPlan.tripParams, { paxId });

export const travellerDetailsFormSelector = (store: ReduxStore, formName: string): TravellerDetailsPayload =>
  get(store.travellersDetails.formData, formName, {});

export const travellerDetailsErrorSelector = (store: ReduxStore, formName: string): TravellerDetailsPayload =>
  get(store.travellersDetails.errors, formName, {});

export const travellerTypeLabel = (store: ReduxStore): string =>
  store.travellerSelection.isFamily ? TRAVELLER_TYPE_KEY.FAMILY : TRAVELLER_TYPE_KEY.INDIVIDUAL;

export const tripType = (store: ReduxStore): string =>
  store.travellerSelection.isSingleTrip ? TRIP_TYPE_KEY.SINGLE_TRIP : TRIP_TYPE_KEY.MULTI_TRIP;
